/**
 * Enum con todos los roles de usuario disponibles en la aplicación
 */
export enum UserRole {
  ADMIN = 'admin', // admin podrá ver todo
  CONSULTOR = 'CONSULTOR', 
  DESARROLLO = 'DESARROLLO',
  FINANZAS = 'FINANZAS',
}
